import React, { useState, useEffect } from 'react'

import CloseIcon from '@mui/icons-material/Close'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import IconButton from '@mui/material/IconButton'
import Modal from '@mui/material/Modal'
import TextField from '@mui/material/TextField'
import Typography from '@mui/material/Typography'
import { generateClient } from 'aws-amplify/data'
import { getUrl } from 'aws-amplify/storage'
import { useNavigate } from 'react-router-dom'

import type { Schema } from '../../../amplify/data/resource'

const client = generateClient<Schema>()

const LoginPage = () => {
  const navigate = useNavigate()
  const [answer, setAnswer] = useState('')
  const [questions, setQuestions] = useState<Schema['AuthDB']['type'][]>([])
  const [questionIndex, setQuestionIndex] = useState(0)
  const [open, setOpen] = React.useState(false)
  const [errorImg, setErrorImg] = useState('')
  const handleClose = () => {
    setOpen(false)
    setAnswer('')
  }
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setAnswer(e.target.value)
  }

  const fetchQuestions = async () => {
    const { data: items } = await client.models.AuthDB.list()
    setQuestions(items)
    setQuestionIndex(Math.floor(Math.random() * items.length))
  }

  const getImageUrl = async () => {
    try {
      const signedUrl = await getUrl({ path: 'pictures/angry.jpeg' })
      return signedUrl.url
    } catch (error) {
      console.error('Failed to get image:', error)
      return null
    }
  }

  const handleAnswerCheck = async () => {
    const errorImg = await getImageUrl()
    if (questions[questionIndex].answer === answer) {
      localStorage.setItem('loggedIn', 'true')
      navigate('/')
    } else {
      setErrorImg(errorImg?.href.toString() ?? '')
      setQuestionIndex(Math.floor(Math.random() * questions.length))
      setOpen(true)
    }
  }

  useEffect(() => {
    fetchQuestions()
  }, [])

  return (
    <Box>
      <Box
        sx={{
          background: 'linear-gradient(135deg, #FFE0E9 0%, #FFC1CC 100%)',
          minHeight: '100vh',
          padding: 4,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 4
        }}
      >
        {questions && questions.length > 0 ? (
          <>
            <Typography variant="h2" fontFamily={'ZCOOL KuaiLe'}>
              请回答安全问题
            </Typography>
            <Typography variant="h4" fontFamily={'ZCOOL KuaiLe'}>
              {questions[questionIndex].question}
            </Typography>
            <TextField
              fullWidth
              id="username"
              variant="outlined"
              value={answer}
              onChange={handleChange}
              margin="normal"
              sx={{ width: '50%' }}
            />
            <Button
              type="submit"
              variant="contained"
              size="large"
              sx={{ mt: 2 }}
              onClick={handleAnswerCheck}
            >
              登录
            </Button>
          </>
        ) : (
          <Typography variant="h3">
            Error loading security questions, please refresh the page and try
            again.
          </Typography>
        )}
      </Box>

      <Modal open={open} onClose={handleClose}>
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            margin: 'auto',
            // width: '90vw',
            width: { xs: 400, md: 700 },
            height: 'auto',
            boxShadow: 24,
            p: 2,
            borderRadius: 2,
            background: 'linear-gradient(135deg, #FFE0E9 0%, #FFC1CC 100%)'
          }}
        >
          <IconButton
            onClick={handleClose}
            sx={{
              position: 'absolute',
              top: 8,
              right: 8
            }}
          >
            <CloseIcon />
          </IconButton>

          <Typography id="modal-modal-title" variant="h6" component="h2">
            回答错误！重新尝试
          </Typography>

          <img
            src={errorImg}
            alt="Angry picture"
            style={{
              maxWidth: '100%',
              maxHeight: '80vh',
              objectFit: 'contain',
              marginTop: '1rem'
            }}
          />
        </Box>
      </Modal>
    </Box>
  )
}

export default LoginPage
